// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-4ad838aa] .cp-utilities-generic_modal-overlay-close{display:none}[data-v-4ad838aa] .cp-utilities-generic_modal{padding:.5rem}", "",{"version":3,"sources":["webpack://./assets/main/vue/cookies/components/CookieModal.vue"],"names":[],"mappings":"AACA,4DACE,YAAA,CAEF,8CACE,aAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
